module.exports = __webpack_public_path__ + "static/assets/e2e60c87c378480714a70bb99dc5b285.png";